module.exports = __webpack_public_path__ + "img/agent_1.8f49b2e9.jpg";